















export default {
    "name": 'ReviewConsultantBox',
    "props": {
        "avatarSrc": String
        "fullname": String
        "justifyEnd": {
            required: false,
            type: Boolean
        }
    },
}

